import type { Directive } from "vue";

/** Leva o scroll até ao alerta bs5 e dá-lhe focus, para o utilizador
 * perceber a mensagem mesmo que a página esteja scrollada. Usar em
 * qualquer alerta de validação/resposta: `v-if="erro" v-foco-alerta="erro"`. */
function focarElemento(el: HTMLElement) {
  if (!el.hasAttribute("tabindex")) el.setAttribute("tabindex", "-1");
  const scroll = () => el.scrollIntoView({ behavior: "smooth", block: "center" });
  requestAnimationFrame(() => {
    scroll();
    el.focus({ preventScroll: true });
    el.animate(
      [
        { boxShadow: "0 0 0 0 currentColor", offset: 0 },
        { boxShadow: "0 0 0 4px currentColor", offset: 0.3 },
        { boxShadow: "0 0 0 0 currentColor", offset: 1 },
      ],
      { duration: 700, easing: "ease-out" },
    );
  });
  // O alerta normalmente aparece logo a seguir a um modal (RequestModal/
  // ConfirmModal, SweetAlert2) fechar — a própria SweetAlert2 só repõe o
  // scroll/padding do <html> no fim da SUA animação de saída (~300ms), o que
  // desloca a página depois do scrollIntoView acima já ter corrido. Sem este
  // reforço, o utilizador ficava com o alerta fora do ecrã sem perceber
  // porquê ("nada aconteceu"). Repetir o scroll é seguro/idempotente.
  setTimeout(scroll, 350);
}

export const vFocoAlerta: Directive<HTMLElement, unknown> = {
  mounted(el) {
    focarElemento(el);
  },
  updated(el, binding) {
    if (binding.value !== binding.oldValue) focarElemento(el);
  },
};
